// Styles
import styles from './VirtualizedTableGroups.module.css';

/**
 * VirtualizedTableGroups
 * @param {object} params
 * @param {React.ReactNode} params.children - Children to render
 * @param {() => void} [params.onMouseLeave] - Called when pointer leaves the table groups
 * @returns {JSX.Element} VirtualizedTableGroups component
 */
function VirtualizedTableGroups({
  children,
  onMouseLeave,
}) {
  return (
    <div
      className={styles['virtualized-table']}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  );
}

export default VirtualizedTableGroups;
